import { SolType } from '@sol/components';

export class AsmSearchType {
  public static readonly tagLabel = SolType.ofPrimitive<string>(
    'tagLabel',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
